import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface MessageQuestionIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const MessageQuestionIcon: React.FC<MessageQuestionIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon message-question')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path d="M448 0H64C28.75 0 0 28.75 0 63.1v287.1C0 387.2 28.75 415.1 64 415.1h96v83.1c0 9.836 11.02 15.5 19.12 9.649L304 415.1H448c35.25 0 64-28.75 64-63.1V63.1C512 28.75 483.3 0 448 0zM464 352c0 8.75-7.25 16-16 16h-160l-80 60v-60H64c-8.75 0-16-7.25-16-16V64c0-8.75 7.25-16 16-16h384c8.75 0 16 7.25 16 16V352zM249.1 268C235.4 268 224 279.4 224 294S235.4 320 249.1 320C264.6 320 276 308.6 276 294S264.6 268 249.1 268zM277.7 96H234.3C201.8 96 176 121.6 176 153.8c0 10.74 9.166 19.83 20 19.83S216 164.6 216 153.8c0-9.914 8.334-18.17 18.33-18.17h43.33c10 0 18.33 8.26 18.33 18.17c0 6.607-3.334 12.39-9.166 15.7L239.3 197.6c-6.668 4.131-10 10.74-10 17.35v13.22c0 10.74 9.166 19.83 20 19.83c10.83 0 20-9.088 20-19.83V226.5l38.33-23.13C325.2 192.7 336 173.7 336 153.8C336 121.6 310.2 96 277.7 96z" />
      </svg>
    </Tooltip>
  );
};
